import {FC} from 'react';
import {ITest} from '@types';
import {CoverageTestBlockWrapper} from '@molecules/CoverageTestBlock.styles';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import CoverageChart from '@atoms/CoverageChart';

ChartJS.register(ArcElement, Tooltip, Legend);

export interface CoverageTestBlockProps {
  test: ITest;
}

const CoverageTestBlock: FC<CoverageTestBlockProps> = ({test}) => {
  const autoCoverage = test.autoCoverage || 0;
  const manualCoverage = test.coverage || 0;
  const emptyCoverage = 100 - autoCoverage - manualCoverage;

  return (
    <CoverageTestBlockWrapper key={emptyCoverage}>
      <Text text={test.name} type="tinyM" color={theme.colors.basic02} />
      <CoverageChart test={test} />
    </CoverageTestBlockWrapper>
  );
};

export default CoverageTestBlock;
